import React from 'react';

import { Icon } from 'semantic-ui-react';
import { SnackbarContent } from 'material-ui';

import { Button } from 'components';

import styles from './MaterialSnackbar.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

const MaterialSnackbar = ({ isSnackbar, onToggleSnackbar }) => {
  return (
    <div className={cx('MaterialSnackbar-wrapper')}>
      {!!isSnackbar && (
        <SnackbarContent
          message={
            <div id="message-id">
              <div className={cx('MaterialSnackbar-icon')}>
                <Icon name="checkmark" />
              </div>
              <div className={cx('MaterialSnackbar-message')}>{isSnackbar}</div>
              <Button
                icon
                className={cx('MaterialSnackbar-closeButton')}
                onClick={() => {
                  onToggleSnackbar('');
                }}>
                <Icon name="close" />
              </Button>
            </div>
          }
        />
      )}
    </div>
  );
};

export default MaterialSnackbar;



// WEBPACK FOOTER //
// ./src/script/components/common/MaterialSnackbar.js